import { SearchQuery } from 'storefront-query-builder'

// Generate all possible SKU variations by progressively removing dash-separated segments
// Example: "base-option1-option2" -> ["base-option1-option2", "base-option1", "base"]
const generateSkuVariations = (sku: string): string[] => {
  const variations: string[] = [sku]
  let currentSku = sku
  while (currentSku.indexOf('-') !== -1) {
    currentSku = currentSku.substr(0, currentSku.lastIndexOf('-'))
    variations.push(currentSku)
  }
  return variations
}

const productActions = {
  async findProductOption ({ dispatch }, { serverItem }) {
    if (serverItem.product_type === 'configurable') {
      let query = new SearchQuery()
      query = query.applyFilter({ key: 'configurable_children.sku', value: { eq: serverItem.sku } })

      const { items } = await dispatch('product/findProducts', {
        query,
        start: 0,
        size: 1,
        options: {
          populateRequestCacheTags: false,
          prefetchGroupProducts: false,
          separateSelectedVariant: true
        }
      }, { root: true })

      return items.length >= 1 ? { sku: items[0].sku, childSku: serverItem.sku } : null
    }

    // For simple products, return the SKU as-is
    // The loop in getProductVariant will handle progressive SKU reduction if needed
    return { sku: serverItem.sku }
  },
  async getProductVariant ({ dispatch }, { serverItem }) {
    try {
      // Generate SKU variations for main SKU
      const skuVariations = generateSkuVariations(serverItem.sku)

      // Query all SKU variations at once
      let query = new SearchQuery()
      query = query.applyFilter({ key: 'sku', value: { in: skuVariations } })

      const { items } = await dispatch('product/findProducts', {
        query,
        start: 0,
        size: skuVariations.length,
        options: {
          populateRequestCacheTags: false,
          prefetchGroupProducts: false
        }
      }, { root: true })

      // Find the first matching product by matching SKU variations to items' parentSku
      let singleProduct = null
      for (const sku of skuVariations) {
        singleProduct = items.find(item => item.parentSku === sku)
        if (singleProduct) {
          serverItem.sku = sku
          break
        }
      }

      // If no match found and parentSku exists, try matching with parentSku directly
      if (!singleProduct && serverItem.parentSku) {
        singleProduct = items.find(item => item.parentSku === serverItem.parentSku)
        if (singleProduct) {
          serverItem.sku = serverItem.parentSku
        }
      }

      // Return null if no product was found
      if (!singleProduct) {
        return null
      }

      return {
        ...singleProduct,
        server_item_id: serverItem.item_id ?? serverItem.server_item_id,
        qty: serverItem.qty,
        server_quote_id: serverItem.quote_id,
        product_option: serverItem.product_option || singleProduct.product_option
      }
    } catch (e) {
      console.error('Could not find product variant:' + e)
      return null
    }
  }
}

export default productActions
